import { startHanziTool } from "./hanzi-tool.js";
import { startTools } from "./start-tools.js";

/**
 * The bundle for the Chinese-to-pinyin converter.
 *
 * The largest of the four by a long way, because it is the only one that reads
 * characters: the decoder, the word lists and every transcription system are
 * in here and in none of the others. That is why there are four bundles rather
 * than one: the numbers page used to carry all of this to say 2026 out loud.
 *
 * Loaded by `layouts/tools/single.html` with `type="module"`, which is
 * deferred by definition, so there is nothing to wait for: the markup this
 * drives has already been parsed by the time it runs.
 *
 * It exports nothing, and that is the point — a module whose whole purpose is
 * a side effect should not also be something other modules import.
 */
startTools(document, new Map([["hanzi", startHanziTool]]));
